<template>
  <div className='animated'>
    <b-card>
      <b-card-header>
        <i class="icon-menu mr1"></i> Data Table Point Transaction Treasury Army
      </b-card-header>
      <b-card-body>
        <Point-Transaction></Point-Transaction>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import PointTransaction from './Table.vue'
export default {
  name: 'point-transaction',
  components: {
    PointTransaction
  }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>